import { queryOptions } from '@tanstack/react-query'

import { getCustomerDocuments } from './documents.service'

export const customerDocumentsQueryOptions = (customerId: string) =>
  queryOptions({
    queryKey: ['customerDocuments', customerId],
    queryFn: async () => getCustomerDocuments(customerId),
  })
